import { QueryObserverOptions, useQuery } from "react-query";
import {   TransactionHistoryItem } from "../@types";
import { APIError, APIResponse, API_URL, get } from "../api";

function useTransactionDetatails(txID?: string,options?: QueryObserverOptions<APIResponse<TransactionHistoryItem>, APIError>) {
  const {
    data: transactionDetails,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery<APIResponse<TransactionHistoryItem>, APIError>(
    `transactionDetails-${txID}`,
    async () =>
      await get(API_URL + `/account/user/account/transactions/${txID}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    transactionDetails,
    isError,
    error,
    isLoading,
    refetch,
    isRefetching,
  };
}

export default useTransactionDetatails;
